'use client';

import React from 'react';
import Image from 'next/image';

const features = [
  {
    text: (
      <span>
        Credit up to <strong className="font-semibold">₹50,000</strong>
      </span>
    ),
    image: '/credit.svg',
  },
  {
    text: (
      <span>
        Low/No-cost <strong className="font-semibold">EMIs</strong>
      </span>
    ),
    image: '/emi.svg',
  },
  {
    text: (
      <span>
        Transparent <strong className="font-semibold">Pricing</strong>
      </span>
    ),
    image: '/transparent-pricing.svg',
  },
  {
    text: (
      <span>
        Totally <strong className="font-semibold">Paperwork-free</strong>
      </span>
    ),
    image: '/no-paperwork.svg',
  },
];

const HeroSection: React.FC = () => {
  return (
    <div className="overflow-scroll grow h-full rounded-t-xl bg-white-normal">
      <div className="w-full flex items-center justify-center flex-col bg-[#F8FAFC] py-7">
        <Image
          className="w-full max-w-80"
          src="/hero-image.svg"
          alt="Hero Image"
          width={0}
          height={0}
        />
        <div className="flex flex-col items-center">
          <h1 className="font-tasa text-3xl font-semibold text-on-primary-subtle">Instant EMI</h1>
          <p className="text-base text-on-primary-subtle">From trusted lenders</p>
        </div>
      </div>

      <div className="px-6 py-8 flex items-center">
        <ul className="flex flex-col justify-start mx-auto gap-5">
          {features.map((feature, index) => (
            <li key={index} className="list-none flex items-center gap-3">
              <Image width={40} height={40} src={feature.image} alt="Feature Image" />
              <p className="text-black-normal text-base">{feature.text}</p>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default HeroSection;
